import {
  RO_DETAIL_COLORS,
  RO_DETAIL_FONT,
  RO_DETAIL_LAYOUT,
} from "../../data/inRepairRoDetailConstants";

export const roDetailPnTableHeaderCellStyle = {
  backgroundColor: `${RO_DETAIL_COLORS.cardBg} !important`,
  color: RO_DETAIL_COLORS.mutedText,
  fontSize: RO_DETAIL_FONT.fieldLabel,
  fontWeight: 400,
  height: "auto",
  p: "6px 8px",
  borderBottom: `1px solid ${RO_DETAIL_COLORS.borderLight}`,
};

export const roDetailPnTableBodyCellStyle = {
  backgroundColor: `${RO_DETAIL_COLORS.cardBg} !important`,
  color: RO_DETAIL_COLORS.primaryText,
  fontSize: RO_DETAIL_FONT.fieldValue,
  fontWeight: 400,
  p: "6px 8px",
  borderBottom: `1px solid ${RO_DETAIL_COLORS.borderLight}`,
};

export const roDetailPnTableRowCellStyle = {
  color: RO_DETAIL_COLORS.primaryText,
  fontSize: RO_DETAIL_FONT.fieldValue,
  fontWeight: 400,
  backgroundColor: RO_DETAIL_COLORS.cardBg,
};

export const roDetailPnTableContainerStyle = {
  border: `1px solid ${RO_DETAIL_COLORS.borderLight}`,
  borderRadius: RO_DETAIL_LAYOUT.cardRadius,
  backgroundColor: RO_DETAIL_COLORS.cardBg,
};

export const roDetailPnTableNoRecordStyle = {
  py: 3,
  color: RO_DETAIL_COLORS.mutedText,
  fontSize: RO_DETAIL_FONT.fieldValue,
  fontWeight: 400,
  backgroundColor: RO_DETAIL_COLORS.cardBg,
};
